import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Id } from '@libs/shared/interfaces/id-dto.interface';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationHttpClient {
  private readonly http = inject(HttpClient);

  public baseUrl = environment.api.url;

  addUserFromKeycloak() {
    return this.http
      .post<Id>(`${this.baseUrl}/authentication/add-user-from-keycloak`, {})
      .subscribe();
  }
}
